// src/components/strumenti/CalcoloPercentuali.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

const MODALITA = [
  { id:"perc_di_numero", label:"% di un numero", desc:"Quanto è il P% di N" },
  { id:"perc_inversa", label:"Percentuale inversa", desc:"V è il P% di quale numero?" },
  { id:"incidenza", label:"Incidenza percentuale", desc:"V è che percentuale di N?" },
  { id:"variazione", label:"Variazione percentuale", desc:"Da A a B, che variazione %?" },
  { id:"aumento", label:"Aumenta di una %", desc:"N aumentato del P%" },
  { id:"sconto", label:"Riduci di una % (sconto)", desc:"N ridotto del P%" },
];

export default function CalcoloPercentuali() {
  const [modo, setModo] = useState("perc_di_numero");
  const [a, setA] = useState("");
  const [b, setB] = useState("");

  const numA = leggiNumero(a);
  const numB = leggiNumero(b);
  const vA = isNaN(numA) ? null : numA;
  const vB = isNaN(numB) ? null : numB;

  let risultato = null, unitaRisultato = "", labelA = "", labelB = "";

  if (modo==="perc_di_numero") {
    labelA = "Percentuale P (%)"; labelB = "Numero N";
    if (vA!==null && vB!==null) risultato = (vA/100)*vB;
  } else if (modo==="perc_inversa") {
    labelA = "Valore V"; labelB = "Percentuale P (%)";
    if (vA!==null && vB!==null && vB!==0) risultato = vA/(vB/100);
  } else if (modo==="incidenza") {
    labelA = "Valore V"; labelB = "Numero totale N";
    if (vA!==null && vB!==null && vB!==0) { risultato = (vA/vB)*100; unitaRisultato = "%"; }
  } else if (modo==="variazione") {
    labelA = "Valore iniziale A"; labelB = "Valore finale B";
    if (vA!==null && vB!==null && vA!==0) { risultato = ((vB-vA)/vA)*100; unitaRisultato = "%"; }
  } else if (modo==="aumento") {
    labelA = "Numero N"; labelB = "Percentuale di aumento (%)";
    if (vA!==null && vB!==null) risultato = vA*(1+vB/100);
  } else if (modo==="sconto") {
    labelA = "Numero N"; labelB = "Percentuale di sconto (%)";
    if (vA!==null && vB!==null) risultato = vA*(1-vB/100);
  }

  const modalitaCorrente = MODALITA.find(m=>m.id===modo);

  return (
    <div>
      <div style={{ marginBottom:12 }}>
        <label style={lbl}>Tipo di calcolo</label>
        <select value={modo} onChange={e=>{setModo(e.target.value);setA("");setB("");}} style={inp}>
          {MODALITA.map(m => <option key={m.id} value={m.id}>{m.label}</option>)}
        </select>
        <div style={{ fontSize:11, color:"#9ca3af", marginTop:4 }}>{modalitaCorrente.desc}</div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>{labelA}</label>
          <input value={a} onChange={e=>setA(e.target.value)} style={inp} placeholder="Es. 20"/>
        </div>
        <div>
          <label style={lbl}>{labelB}</label>
          <input value={b} onChange={e=>setB(e.target.value)} style={inp} placeholder="Es. 100"/>
        </div>
      </div>

      <div style={{ background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Risultato</div>
        <div style={{ fontSize:24, fontWeight:800, color:"#6d28d9" }}>
          {risultato===null ? "—" : risultato.toLocaleString("it-IT",{maximumFractionDigits:4})}
          {unitaRisultato && <span style={{ fontSize:16, marginLeft:4 }}>{unitaRisultato}</span>}
        </div>
      </div>

      <button onClick={()=>{setA("");setB("");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
